export default __webpack_public_path__ + "static/media/roe_gray.d810cd4b.svg";